import { documentMetadataUserEditEntryId } from 'features/knowledgeDocumentViewer/utils/metadataUserEditIds'

export function collectSearchDocumentUserEditEntryIds(
  bqDocumentIds: readonly string[],
  siteId: string
): string[] {
  if (!siteId || bqDocumentIds.length === 0) return []
  const entryIds = new Set<string>()
  for (const bqDocumentId of bqDocumentIds) {
    if (!bqDocumentId) continue
    entryIds.add(documentMetadataUserEditEntryId(siteId, bqDocumentId))
  }
  return Array.from(entryIds)
}
